const EmptyItems = ({ message = "داده ای برای نمایش یافت نشد" }) => {
  return <p className="alert border-info text-center">{message}</p>;
};

export default EmptyItems;
